//#region imports
import React from 'react';
import { OPERATORS } from 'configs/constants';
import styles from './styles';
import cn from 'classnames';
import { Swiper, SwiperSlide, SwiperClass } from 'swiper/react';
import { Navigation } from 'swiper/modules';
import Container from '@mui/material/Container';
import 'swiper/css';
import 'swiper/css/navigation';
//#endregion

interface IProps {
  className?: string;
  currentNumber: number;
  onChangeNumber: (value: number) => void;
}

const OperatorSlider: React.FC<IProps> = ({ className, onChangeNumber, currentNumber }) => {
  const classes = styles();

  const onChange = ({ activeIndex }: SwiperClass) => onChangeNumber(activeIndex);

  return (
    <Container className={ cn(className, classes.root) } >
      <Swiper
        className={ classes.slider }
        navigation
        modules={ [Navigation] }
        spaceBetween={ 18 }
        slidesPerView={ 'auto' }
        centeredSlides
        onSlideChange={ onChange }
        initialSlide={ currentNumber }
      >
        { OPERATORS.map(({ key, component: Component }, index) => (
          <SwiperSlide className={ classes.slide } key={ key } virtualIndex={ index } >
            <div className={ classes.slideContent }>
              <Component />
            </div>
          </SwiperSlide>
        )) }
      </Swiper>
    </Container>
  );
};

export default OperatorSlider;
